import React from "react";
import "./Cart.css";
import CartTable from "./CartTable";
import { Button } from "@mui/material";
import { Link } from "react-router-dom";
import Checkout from "./Checkout";
import {
  useGetUserCartQuery,
} from "../../../redux-toolkit/features/rewards/rewardsApiSlice";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import { useSelector } from "react-redux";
import { selectedTheme } from "../../../redux-toolkit/features/theme/themeSlice";
import "../../Books/Books.css";

const Cart = () => {
  useGetUserCartQuery({
    refetchOnMountOrArgChange: true,
  });
  const theme = useSelector(selectedTheme);

  return (
    <div className={theme ? "darkBook" : ""}>
      <div className="container__mact">
        <div className="bg__rewards">
          <div className="cart">
            <div className="container">
              <div className="books__breadcrumbs">
                <Link
                  to="/quest"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    gap: "10px",
                    textDecoration: "none",
                  }}
                >
                  <div className="books__breadcrumbshome">
                    <HomeRoundedIcon
                      sx={{
                        padding: "5px",
                        color: theme ? "var(--pblue)" : "var(--grey600)",
                        "&:hover": {
                          color: theme ? "white" : "#444444",
                        },
                      }}
                    />
                  </div>
                  <h4
                    className="ftwt__r"
                    style={{
                      color: theme ? "var(--pblue)" : "var(--grey600)",
                    }}
                  >
                    Home
                  </h4>
                </Link>
                <PlayArrowIcon
                  sx={{
                    fontSize: "20px",
                    color: theme ? "var(--pblue)" : "var(--grey600)",
                  }}
                />
                <Link style={{ textDecoration: "none" }} to="/quest/rewards">
                  <h4
                    className="ftwt__r"
                    style={{
                      color: theme ? "var(--pblue)" : "var(--grey600)",
                    }}
                  >
                    Rewards
                  </h4>
                </Link>
                <PlayArrowIcon
                  sx={{
                    fontSize: "20px",
                    color: theme ? "var(--pblue)" : "var(--grey600)",
                  }}
                />
                <h4
                  className="ftwt__r"
                  style={{
                    color: theme ? "var(--pblue)" : "var(--grey600)",
                  }}
                >
                  Cart
                </h4>
              </div>
              <div className="cart__layout">
                <div className="cart__leftLayout">
                  <div className="cart__left">
                    <CartTable />
                  </div>

                  <div className="cart__leftAction">
                    <Link
                      to={"/quest/rewards"}
                      style={{ textDecoration: "none" }}
                    >
                      <Button
                        sx={{
                          color: "gray",
                          borderColor: "gray",
                          marginRight: "16px",
                          fontSize: "16px",

                          "&:hover": { color: "var(--pblue)" },
                        }}
                        variant="outlined"
                      >
                        Add more items
                      </Button>{" "}
                    </Link>
                  </div>
                </div>
                <div className="cart__right">
                  <Checkout />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cart;
